import { Skeleton } from 'antd';
import styled from 'styled-components';
import { Button } from 'components/Button';
import { isMobile } from 'utils';

export const AuthButton = styled(Button)`
  &&& {
    justify-content: center;
    align-items: center;
    padding: 0 16px;
    min-width: 135px;
    height: var(--ft-btn-height-sm);
    border-radius: 10px;
    font-weight: 500;
    font-size: var(--ft-font-size-300);
    line-height: var(--ft-line-height-100);
    letter-spacing: -0.02em;
    text-align: center;
  }
`;

export const AuthSignUpButton = styled(AuthButton)`
  &&& {
    background: var(--v3-primary-color);
    color: var(--v3-black-0);
    :hover {
      color: var(--v3-black-0);
      background: var(--v3-primary-color);
    }
  }
`;

export const AuthButtonSkeleton = styled(Skeleton.Button)`
  &&& {
    justify-content: center;
    align-items: center;
    min-width: 135px;
    height: 40px;
    border-radius: 10px;
    font-weight: 500;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: -0.02em;
    text-align: center;
  }
`;

export const AuthButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const ModalBody = styled.div`
  width: ${isMobile() ? '100vw' : '500px'};
  min-height: 500px;
  max-height: ${isMobile() ? '100vh' : '90vh'};
`;
